<script lang="ts" setup>
import {ref} from "vue";
import useStore from "@src/stores/store";
import {ForwardIcon} from "@heroicons/vue/24/outline";

let SkipLinkFocused = ref(false);

const store = useStore();
</script>

<template>
    <div class="mb-7 h-7 xs:hidden md:block flex-shrink-0">
        <a
            :class="{
        absolute: !SkipLinkFocused,
        'right-2500': !SkipLinkFocused,
      }"
            class="outline-none"
            href="#mainContent"
            title="Skip to main content"
            @blur="SkipLinkFocused = false"
            @focus="SkipLinkFocused = true"
        >
            <ForwardIcon class="w-7 h-6 text-indigo-300" />
        </a>

        <button
            :class="{ hidden: SkipLinkFocused }"
            aria-label="dChat logo"
            class="outline-none"
        >
            <img
                v-if="!store.settings.darkMode"
                alt="dChat Logo"
                class="w-8 h-8"
                src="../../../../assets/images/dchat_login_logo.png"
            />
            <img
                v-else
                alt="dChat Logo"
                class="w-8 h-8 opacity-80"
                src="../../../../assets/images/dchat_login_logo.png"
            />
        </button>
    </div>
</template>
